import strings from "../locales/ro.json"

export default function statuteFromGroups(user) {
    if (user.groups.includes(strings.basicUserGroups.juniors))
        return "junior"
    if (user.groups.includes(strings.basicUserGroups.alumni))
        return "alumni"
    if (user.groups.includes(strings.basicUserGroups.seniors))
        return "senior"
    if (user.groups.includes(strings.basicUserGroups.friends))
        return "friend"
    if (user.groups.includes(strings.basicUserGroups.freezed))
        return "freezed"

    return "!Error!"
}